export const roles = {
  pss: process.env.REACT_APP_ROL_PSS!,
  lector: process.env.REACT_APP_ROL_LECTOR!,
  admin: process.env.REACT_APP_ROL_ADMIN!,
  radicador: process.env.REACT_APP_ROL_RADICADOR!,
  auditor: process.env.REACT_APP_ROL_AUDITOR!,
  financiero: process.env.REACT_APP_ROL_FINANCIERO!,
  processAdministrator: process.env.REACT_APP_ROL_PROCESS_ADMINISTRATOR!,
  generic: process.env.REACT_APP_ROL_GENERIC!,
};

export const accesRoles: IAccesRoles = {
  adminUser: [roles.admin],
  healthProvider: [roles.pss],
  generic: [roles.generic],
  validator: [roles.admin, roles.radicador],
  auditor: [roles.admin, roles.auditor],
  finance: [roles.admin, roles.financiero],
  financialModule: [roles.admin, roles.auditor, roles.financiero],
  financialModuleWithHealthProvider: [
    roles.admin,
    roles.auditor,
    roles.financiero,
    roles.pss,
  ],
  processAdministrator: [roles.admin, roles.processAdministrator],
  usersSSSA: [
    roles.admin,
    roles.financiero,
    roles.auditor,
    roles.radicador,
    roles.lector,
  ],
  reader: [
    roles.admin,
    roles.pss,
    roles.lector,
    roles.auditor,
    roles.financiero,
    roles.radicador,
  ],
  auditorWithHealthProvider: [roles.admin, roles.auditor, roles.pss],
};

export interface IAccesRoles {
  adminUser: string[];
  healthProvider: string[];
  generic: string[];
  validator: string[];
  auditor: string[];
  finance: string[];
  financialModule: string[];
  financialModuleWithHealthProvider: string[];
  processAdministrator: string[];
  usersSSSA: string[];
  reader: string[];
  auditorWithHealthProvider: string[];
}
